import { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { DynamicFieldNameRootContext } from './DynamicFieldNameRootContext';
import { useAppSelector } from 'src/app/store/hooks';
import type { PassengerRead } from 'src/common/external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export function useApplyPassengerDispatchNotes() {
  const { getValues, setValue, formState } = useFormContext();
  const { dirtyFields } = formState;
  const { isRideOrderingPortalUser } = useUserRoles();

  const fieldNameRoot = useContext(DynamicFieldNameRootContext);

  const passenger: PassengerRead | null | undefined = useAppSelector(
    (state) => state.addATrip.selectedPassenger
  );

  // Set when editing or cloning. A clone has no id but already carries the
  // source trip's notes, which the passenger's notes must not replace.
  const isPrefilledFromTrip = useAppSelector(
    (state) => !!state.addATrip.selectedTrip
  );

  const tripDispatcherNotesDirty = dirtyFields.trips?.some(
    (trip: any) => !!trip.dispatcher_notes
  );

  useEffect(() => {
    const id = getValues('id');

    const allowUpdate =
      !isRideOrderingPortalUser &&
      !id &&
      !isPrefilledFromTrip &&
      !tripDispatcherNotesDirty;

    if (allowUpdate) {
      setValue(
        `${fieldNameRoot}.dispatcher_notes`,
        passenger?.dispatcher_notes
      );
    }
  }, [
    dirtyFields,
    fieldNameRoot,
    getValues,
    isPrefilledFromTrip,
    isRideOrderingPortalUser,
    passenger?.dispatcher_notes,
    setValue,
    tripDispatcherNotesDirty,
  ]);
}
